// ─── Feature Flags ────────────────────────────────────────────────────────────
// Each entry: { enabled, label, description, category }
//
// To toggle a feature anywhere in the app, flip `enabled` here.
// The FeatureContext / useFeature / FeatureGate utilities pick this up
// automatically — no other files need to change.
//
// Categories (for grouping in future admin UIs):
//   'messaging'  | 'tasks' | 'hr' | 'crm' | 'admin' | 'general'

// All features default false — the server (entitlements) is the sole source of truth.
// A static `true` here would bypass extension-install gating for tenants whose tier
// doesn't include the feature, because absent entitlement keys don't override a static true.
const features = {
  // ── Messaging ───────────────────────────────────────────────────────────────
  gif:           { enabled: false, label: 'GIF Picker',      description: 'Tenor GIF search in chat.',            category: 'messaging' },
  cameraCapture: { enabled: false, label: 'Camera Capture',  description: 'Camera capture in chat.',              category: 'messaging' },
  voiceCall:     { enabled: false, label: 'Voice Calls',     description: '1-to-1 voice calling.',                category: 'messaging' },
  voiceCaves:    { enabled: false, label: 'Voice Caves',     description: 'Group voice-channel rooms.',           category: 'messaging' },

  // ── CRM & Sales ─────────────────────────────────────────────────────────────
  lms:           { enabled: false, label: 'Lead Management', description: 'Lead pipeline and analytics.',         category: 'crm' },

  // ── Communication ───────────────────────────────────────────────────────────
  phone_dialer:  { enabled: false, label: 'Phone Dialer',   description: 'Incoming call detection, recording, and CRM sync (Android).', category: 'crm' },
};

export default features;
